import React from "react";
const getFillColor = (color: string) => {
  return color === "currentColor" ? `` : `var(--color-${color})`;
};
const SvgQuestionIcon = ({ title, theme = null, titleId = "", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 64 64"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M32 2a30 30 0 1 0 30 30A30.034 30.034 0 0 0 32 2Zm-2 49a3 3 0 1 1 3-3 3 3 0 0 1-3 3Zm10.1-23.093a34.832 34.832 0 0 1-4.126 4.013 15.533 15.533 0 0 0-3.359 3.6 8.87 8.87 0 0 0-.818 4.534h-3.244a13.574 13.574 0 0 1 .906-6.081 12.973 12.973 0 0 1 3.371-4.013c3.878-3.279 5.208-4.722 5.208-7.875 0-3.718-2.627-5.359-6.39-5.359a17.034 17.034 0 0 0-8.2 2.164l-1.484-3.4A21.12 21.12 0 0 1 31.9 13q4.8 0 7.472 2.365a8.448 8.448 0 0 1 2.667 6.667 9.021 9.021 0 0 1-1.939 5.875Z"
      fill="currentColor"
    />
  </svg>
);
export interface Props {
  color?: string;
  width?: string;
  height?: string;
  title: string;
  titleId?: string;
  theme?: any;
  fill?: string;
}
const SvgQuestionStyle = ({
  color = "currentColor",
  title,
  fill,
  ...props
}: Props) => (
  <SvgQuestionIcon
    color={getFillColor(color)}
    className={color === "currentColor" ? "icon-current-color" : ""}
    {...(color !== "currentColor"
      ? { style: { color: getFillColor(color), fill: getFillColor(color) } }
      : null)}
    fill={fill ?? getFillColor(color)}
    title={title}
    {...props}
  />
);
export const QuestionIcon: any = SvgQuestionStyle;
export default QuestionIcon;
